/* eslint-disable no-case-declarations */
/* eslint-disable prefer-destructuring */
const convertDate = (format, date) => {
  if (date) {
    const fullMonthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const shortMonthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const suffix = ['st', 'nd', 'rd', 'th'];
    let displayValue;
    let day;
    let month;
    let year;
    switch (format) {
      case 'dd/mm/yyyy':
        const arr = date.split('/');
        year = arr[2];
        month = arr[1];
        day = arr[0];
        displayValue = `${day} ${shortMonthNames[month - 1]} ${year}`;
        return displayValue;
      case 'ddth monthName yyyy':
        const a = date.split('/');
        year = a[2];
        month = Number(a[1]);
        day = Number(a[0]);
        displayValue = `${
          day.toString() +
          ((day >= 11 && day <= 13) || (day % 10) - 1 > 3 || (day % 10) - 1 < 0
            ? suffix[3]
            : suffix[(day % 10) - 1])
        } ${fullMonthNames[month - 1]} ${year}`;
        return displayValue;
      case "dd monthname 'shortyear":
        const temp = date.split('/');
        if (temp.length < 3) return date;
        year = temp[2].substr(-2);
        month = temp[1];
        day = temp[0];
        displayValue = `${day} ${fullMonthNames[month - 1]} '${year}`;
        return displayValue;
      case "dd shortmonth shortyear'":
        const _temp = date.split('/');
        if (_temp.length < 3) return date;
        year = _temp[2].substr(-2);
        month = _temp[1];
        day = _temp[0];
        displayValue = `${day} ${shortMonthNames[month - 1]} ${year}'`;
        return displayValue;
      case 'dd-mm-yyyy':
        day = date.getDate();
        month = date.getMonth() + 1;
        year = date.getFullYear();
        // eslint-disable-next-line require-jsdoc
        displayValue = `${day < 10 ? `0${day}` : `${day}`}-${
          month < 10 ? `0${month}` : `${month}`
        }-${year}`;
        return displayValue;
      case "shortMonthName 'shortyear":
        const _tmp = date.split('/');
        if (_tmp.length < 3) return date;
        year = _tmp[2].substr(-2);
        month = _tmp[1];
        day = _tmp[0];
        displayValue = `${shortMonthNames[month - 1]} '${year}`;
        return displayValue;
      default:
        break;
    }
  }
};
export default convertDate;
